import { inject, Injectable } from "@angular/core";

import { HttpService } from "../../shared/services/http.service";
import { jwtDecode } from "jwt-decode";
import { AppToken } from "../models/app-token.model";
import { LoggerService } from "../../shared/services/log.service";
import { UserService } from "../../shared/services/user.service";

@Injectable({providedIn: 'root'})
export class AuthService{

  private httpService = inject(HttpService);

  // baseUrl = environment.AUTH_URL;

  // login(payload: SignIn): Promise<ApiResponse<SignInResponse>> {
  //   return lastValueFrom(this.httpService.post(this.baseUrl+'/auth/signin', payload));
  // }

  // setToken(tokens:SignInResponse){
  //   localStorage.setItem('token', tokens.token);
  //   localStorage.setItem('refresh_token', tokens.refreshToken);
  //   const decodedToken = jwtDecode(tokens.token) as AppToken;
  //   localStorage.setItem('exp', decodedToken.exp.toString());
  // }

  // getDecodedToken(){
  //   const token = this.getAccessToken();
  //   const decodedToken = jwtDecode(token) as AppToken;
  //   return decodedToken;
  // }

  // verifyUserLogin(){
  //   const token = this.getAccessToken();
  //   return token ? true : false;
  // }

  //  getAccessToken(){
  //   const token = localStorage.getItem("token");
  //   const expTime = localStorage.getItem("exp");
  //   const validToken = (+expTime! > Math.floor(Date.now() / 1000)) && token;
  //   return validToken ?  token : "";
  // }







  isAuthorizedUser = false;
  constructor(
    private logService: LoggerService,
    private userService: UserService
  ) {}

  /**
   * Save access token and change isAuthorizedUser status
   *
   * @param {string} token auth token string
   * @param {string} refreshToken refresh token string
   * @return {boolean}
   * @memberof AuthService
   */
  loginUser(token: string, refreshToken: string): boolean {
    try {
      this.setAccessToken(token);
      this.setRefreshToken(refreshToken);
      this.isAuthorizedUser = true;
      return this.isAuthorizedUser;
    } catch (err) {
      this.isAuthorizedUser = false;
      this.logService.exception('Something went wrong', 101);
      return this.isAuthorizedUser;
    }
  }

  getDecodedToken(): AppToken {
    const token = this.getAccessToken();
    const decodeToken = jwtDecode(token);
    return decodeToken as AppToken;
  }

  /**
   * Get access token from local storage
   *
   * @return {*}  {(string | null)}
   * @memberof AuthService
   */
  getAccessToken(): string {
    try {
      return localStorage.getItem('token') ?? '';
    } catch (error) {
      this.logService.exception('Exception in getAccess Token', 104);
      return '';
    }
  }

  /**
   * save access token and save isLoggedIn status to local storage
   *  private function
   * @private
   * @param {string} token token string get after authentication request
   * @memberof AuthService
   */
  private setAccessToken(token: string) {
    try {
      localStorage.setItem('token', token);
      // set access Token expire time
      const millisecondForADay = 24 * 60 * 60 * 1000;
      const nextHour = new Date().getTime() + millisecondForADay;
      localStorage.setItem('tokenExpiryTime', nextHour.toString());
    } catch (error) {
      this.logService.exception('Exception in setAccess Token', 105);
    }
  }

  /**
   * set refresh tokens
   *
   * @private
   * @param {string} refreshToken
   */
  private setRefreshToken(refreshToken: string) {
    try {
      localStorage.setItem('refreshToken', refreshToken);
      // set access Token expire time
      const millisecondForADay = 24 * 60 * 60 * 1000;
      const nextDay = new Date().getTime() + millisecondForADay;
      localStorage.setItem('refreshTokenExpiryTime', nextDay.toString());
    } catch (error) {
      this.logService.exception('Exception in setAccess Token', 105);
    }
  }

  /**
   * Verify user login
   *
   * @return {*}  {boolean}
   * @memberof AuthService
   */
  verifyUserLogin(): boolean {
    const token = localStorage.getItem('token');
    const tokenExpiryTime = localStorage.getItem('tokenExpiryTime');
    const isTimeNotExpired = +tokenExpiryTime! > new Date().getTime();
    const isValidUser = token && isTimeNotExpired;

    if (isValidUser) {
      this.isAuthorizedUser = true;
      return this.isAuthorizedUser;
    } else {
      this.isAuthorizedUser = false;
      return this.isAuthorizedUser;
    }
  }

  /**
   * Logout user and reset all auth activity
   *
   * @memberof AuthService
   */
  logout() {
    try {
      // TODO:(jeni): isApi call needed?
      this.isAuthorizedUser = false;
      this.userService.clearUserDetails();
      localStorage.clear();
    } catch (error) {
      this.logService.exception('Exception in logout', 107);
    }
  }



}
